import { ReactComponent as Icon } from "../assets/images/gps.svg";

const IconGPS = () => (
  <div className="icon-gps">
    <Icon />
  </div>
);

export default IconGPS;
